( function () {
    'use strict';
    e.ecom.productlist = {};
    e.ecom.productlist.init = function () {
        if ( jQuery( '.e-productlist' ).length === 1 && jQuery( '.e-productdetails' ).length === 0 ) {
            e.ecom.productlist.sort.init();
            e.ecom.productlist.filter.init();
        }
    };
    e.ecom.productlist.sort = {};
    e.ecom.productlist.sort.init = function () {
        var jSort = jQuery( '#Sort' ).on( 'change', function () {
            var arrSelectSortValue = jQuery( '#Sort' ).val().split( ' ' );
            if ( arrSelectSortValue.length === 2 ) {
                jQuery( '#SortBy' ).val( arrSelectSortValue[ 0 ] );
                jQuery( '#SortOrder' ).val( arrSelectSortValue[ 1 ] );
            }
            else {
                jQuery( '#SortBy,#SortOrder' ).val( '' );
            }
            this.form.submit();
        } );
        jSort.find( 'option[value="' + jQuery( '#SortBy' ).val() + ' ' + jQuery( '#SortOrder' ).val() + '"]' ).prop( 'selected', true );
    };
    e.ecom.productlist.filter = {};
    e.ecom.productlist.filter.inputTarget = null;
    e.ecom.productlist.filter.submitTimeout = null;
    e.ecom.productlist.filter.submitTimeoutTime = 10;
    e.ecom.productlist.filter.refreshBetween = false;
    e.ecom.productlist.filter.init = function () {
        e.ecom.productlist.filter.bindCheckboxes();
        e.ecom.productlist.filter.bindToggleButtons();
        e.ecom.productlist.filter.bindSubmitAndResetButtons();
    };
    e.ecom.productlist.filter.bindCheckboxes = function () {
        jQuery( '.e-productlist-filters' ).find( 'form' ).on( 'change', ':checkbox, :radio', function () {
            //stop form sumbit fra at fyrer hvis brugeren er i gang med at vælge flere filtre
            clearTimeout( e.ecom.productlist.filter.submitTimeout );
            //Check om bruger klikker p&aring; samme filter 2 gange i træk og dermed egentligt ikke ændre noget, og derfor b&oslash;r vi heller ikke sætte et nyt submit timeout
            if ( e.ecom.productlist.filter.inputTarget !== this ) {
                e.ecom.productlist.filter.inputTarget = this;
                //sæt timeout s&aring; brugeren kan n&aring; at vælge flere hvis man skulle &oslash;nske det
                e.ecom.productlist.filter.submitTimeout = setTimeout( function () {
                    var jInputTarget = jQuery( e.ecom.productlist.filter.inputTarget );
                    if ( jInputTarget.is( '.reset-filter' ) === true ) {
                        jInputTarget.closest( 'fieldset' ).find( ':checkbox, :radio' ).not( '.reset-filter' ).prop( 'checked', false );
                    }
                    else {
                        jInputTarget.closest( 'fieldset' ).find( '.reset-filter' ).prop( 'checked', false ).prop( 'checked', function () {
                            return jInputTarget.closest( 'fieldset' ).find( ':checkbox, :radio' ).filter( ':checked' ).length === 0;
                        } );
                    }
                    if ( jInputTarget.is( '.e-modal-fixed :checkbox' ) === false ) {
                        if(e.ecom.productlist.filter.refreshBetween === true){
                            e.ecom.productlist.filter.inputTarget.form.submit();
                        }
                    }
                }, e.ecom.productlist.filter.submitTimeoutTime );
            }
        } ).find( '.reset-filter' ).each( function () {
            var jResetFilter = jQuery( this );
            jResetFilter.prop( 'checked', function () {
                return jResetFilter.closest( 'fieldset' ).find( ':checkbox, :radio' ).filter( ':checked' ).length === 0;
            } );
        } );
    };
    e.ecom.productlist.filter.bindToggleButtons = function () {
        jQuery( '.js-e-toggle-filters' ).on( 'click', function ( event ) {
            event.preventDefault();
            jQuery( '.e-productlist-filters' ).toggleClass( 'e-modal e-modal-fixed' );
            jQuery( document.body ).toggleClass( 'e-modal-fixed-backdrop' );
        } );
    };
    e.ecom.productlist.filter.bindSubmitAndResetButtons = function () {
        jQuery( '.apply-all-filters' ).on( 'click', function ( event ) {
            event.preventDefault();
            jQuery( '.e-productlist-filters' ).find( 'form' ).trigger( 'submit' );
        } );
        jQuery( '.reset-all-filters' ).on( 'click', function ( event ) {
            event.preventDefault();
            jQuery( '.e-productlist-filters' ).find( 'form' ).find( ':checkbox, :radio' ).prop( 'checked', false ).end().trigger( 'submit' );
        } );
    };
}() );
